/** id_municipio permitidos para filtros de municipio en DatosTematicos, DatosForestales y LandingPage */
export const MUNICIPIOS_IDS = [
  34903, 34901, 34246, 34245, 34236, 34234, 34233, 34231, 34229, 34228,
  34223, 34222, 34218, 34215, 34214, 34211, 34208, 34202, 34199, 34192,
  34190, 34179, 34176, 34175, 34171, 34170, 34169, 34168, 34163, 34161,
  34160, 34158, 34157, 34154, 34151, 34149, 34147, 34143, 34140, 34139,
  34136, 34135, 34132, 34129, 34126, 34124, 34122, 34116, 34114, 34113,
  34112, 34110, 34109, 34107, 34101, 34100, 34094, 34093, 34092, 34091,
  34089, 34083, 34080, 34074, 34073, 34071, 34068, 34067, 34062, 34061,
  34056, 34055, 34052, 34049, 34047, 34041, 34039, 34038, 34037, 34036,
  34034, 34028, 34027, 34025, 34020, 34015, 34005, 34004, 34003,
] as const
